// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__ISK0H","hover":"classes_hover__3FVzm","title":"classes_title__3l9mh","socials":"classes_socials__1LSR2"};